// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";


// import required modules
import { Pagination } from "swiper";
import { Autoplay } from "swiper";

import testmonials from "./data"
import Testimonial from "./Testimonial"

import "./testimonials.css";

const Testimonials = () => {
	return (
	    <section id="testimonials" >
			<h2 data-aos="fade-up" className="title">Testimonials</h2>
			<p data-aos="fade-up" className="filialeservices_title-1"> <h4>What our customers say about us ?</h4></p>
			<Swiper
				slidesPerView={1}
				spaceBetween={20}
						breakpoints={{
							601:{slidesPerView:1},
							1025:{slidesPerView:1}
						}}
				pagination={{
				clickable: true,
				}}
				modules={[Pagination, Autoplay]}
						autoplay={true}
				className="mySwiper"
     		 >
				{testmonials.map(testimonial =>(
               <SwiperSlide key={testimonial.id}>
				<Testimonial testimonial={testimonial}/>
				</SwiperSlide>
				))}
     	   </Swiper>
		</section>
	)
}

export default Testimonials
 